export default "__VITE_ASSET__C_X8z0YB__";